// @flow
import { $formSpyValues } from './model/store'

import type { FormSpyValues } from './types'

/*
  Функция для извлечения из storage значений
  сохраненных в FormSpyManager.STORAGE_KEY
*/
export function getSpyValues(): FormSpyValues {
  return $formSpyValues.getState()
}

/**
 * Return value from spy storage
 */
export function getSpyValue(name: $Keys<FormSpyValues>): $Values<FormSpyValues> {
  const values = getSpyValues()

  return values[name] ?? undefined
}
